import { PusherActionType, PusherReduxAction } from '../../../../../../../../redux/pusher/PusherActions';
import { put, select } from 'redux-saga/effects';
import { getSelectedTimelines } from '../../../selectors';
import { fetchExtensionEntry } from '../../timelineEntries/fetchExtensionEntries';
import { selectExtensionPeriodEntriesSaga } from '../../../selectors-saga';
import { ExtensionTimelineEntry } from '../../../../../../../../common/types/timeline/ExtensionPeriodEntryType';
import { scheduleActions } from '../../../actions';

export function* handleExtensionPeriodEntryCreate(action: PusherReduxAction<PusherActionType.EXTENSION_PERIOD_CREATED>) {
  const selectedTimelines = yield select(getSelectedTimelines);
  if (!selectedTimelines || selectedTimelines.length === 0 || !action.payload) return;

  const entryId = action.payload;

  const fullEntry = yield* fetchExtensionEntry(entryId);
  const entries = yield* selectExtensionPeriodEntriesSaga();
  const updatedEntries = [...entries, fullEntry as ExtensionTimelineEntry];

  yield put(scheduleActions.setExtensionPeriodTimelineEntries(updatedEntries));
}
